import { withInstall } from '../../utils/install';
import CountUp from './index.vue';

export const IvueCountUp = withInstall(CountUp);
export default IvueCountUp;

export * from './index.vue';
